import { Box } from "./Box"
import { srOnlyClassName } from "./sronly.css"

/**
 * The children are only visible to screen readers
 */
export function SROnly({ children = null }: { children?: React.ReactNode }) {
	return <Box className={srOnlyClassName}>{children}</Box>
}
